import { Type } from '@angular/core';
import { ActivatedRoute, ResolveFn } from '@angular/router';

export interface MenuItem {
  icon?: string;
  label: string;
  routerLink: string;
}

export function asMenu(route: Partial<ActivatedRoute>): MenuItem[] {
  return (
    route.routeConfig?.children
      ?.filter(
        route =>
          route.path && !route.redirectTo && !route.data?.['hideFromMenu'],
      )
      .map(child => ({
        icon: child.data && child.data['icon'],
        label: buildTitle(child.title),
        routerLink: child.path || '',
      })) || []
  );
}

function buildTitle(
  title?:
    | string
    | Type<{
        resolve: ResolveFn<string>;
      }>
    | ResolveFn<string>,
) {
  if (typeof title === 'string') {
    return title;
  }

  return 'ERROR';
}
